import { render, staticRenderFns } from "./pos-checkout-keyboard.vue?vue&type=template&id=4613c19a&scoped=true&"
import script from "./pos-checkout-keyboard.ts?vue&type=script&lang=ts&"
export * from "./pos-checkout-keyboard.ts?vue&type=script&lang=ts&"
import style0 from "./pos-checkout-keyboard.scss?vue&type=style&index=0&id=4613c19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613c19a",
  null
  
)

export default component.exports